import React, { useCallback, useMemo, useEffect } from 'react';
import { useRecoilState } from 'recoil';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import theme from '@ecp/common/src/style/theme/default';
import GoodOptionGroup from "@fo-pages/good/summary/option/GoodOptionGroup";
import {FlexBoxColumn} from "@ecp/common/src/layouts/flex/styled";
import GoodOptionItemList from "@fo-pages/good/summary/option/GoodOptionItemList";
import {goodOptionListState} from "@fo-recoil/good/atom";

const CartPopupOptionSelect = ({
  isGroup,
  // floatingType,
  subGoodItemList,
  subGoodDetail,
  additionItemList,
  selectedGoodDetail,
  handleDropDownOption,
  handleGroupDropDownOption,
  handleSelectOptionContainerHeight,
  ...goodDetail
}) => {
  
  const [goodOptionList, setGoodOptionList] = useRecoilState(goodOptionListState);

  const currentItemList = useMemo(() => selectedGoodDetail?.itemNodeList, [selectedGoodDetail?.itemNodeList]);

  useEffect(() => {
    if (!isGroup && !goodDetail.multiItem && goodOptionList.length === 0 && goodDetail.itemList?.length > 0) {
      setGoodOptionList([{ ...goodDetail.itemList?.[0], ...goodDetail, count: 1 }]);
    }
  }, [goodDetail, goodOptionList.length, isGroup, goodDetail.itemList, setGoodOptionList]);

  const optionLabelList = useMemo(
    () => [
      selectedGoodDetail?.itemComposeName01,
      selectedGoodDetail?.itemComposeName02,
      selectedGoodDetail?.itemComposeName03,
      selectedGoodDetail?.itemComposeName04,
      selectedGoodDetail?.itemComposeName05,
    ],
    [
      selectedGoodDetail?.itemComposeName01,
      selectedGoodDetail?.itemComposeName02,
      selectedGoodDetail?.itemComposeName03,
      selectedGoodDetail?.itemComposeName04,
      selectedGoodDetail?.itemComposeName05,
    ]
  );
  
  const handleSelectOption = useCallback(
    (option) => {
      handleDropDownOption(option);
      handleSelectOptionContainerHeight();
    },
    [handleDropDownOption, handleSelectOptionContainerHeight]
  );
  
  const handleSelectGroupOption = useCallback(
    (subGood) => {
      handleGroupDropDownOption(subGood);
      handleSelectOptionContainerHeight();
    },
    [handleGroupDropDownOption, handleSelectOptionContainerHeight]
  );
  
  return (
    <FlexBoxColumn width={'100%'}>
      {isGroup && (
        <CartGoodOptionContainer>
          <GoodOptionGroup
            floatingType
            subGoodItemList={subGoodItemList}
            subGoodDetail={subGoodDetail}
            onSelect={handleSelectGroupOption}
          />
        </CartGoodOptionContainer>
      )}
      {currentItemList?.length > 0 && selectedGoodDetail?.multiItem && (
        <CartGoodOptionContainer>
          <GoodOptionItemList
            floatingType
            styleProps={{ width: '100%', height: '150px' }}
            optionLabelList={optionLabelList}
            itemNodeList={currentItemList}
            onSelect={handleSelectOption}
            handleSelectOptionContainerHeight={handleSelectOptionContainerHeight}
          />
        </CartGoodOptionContainer>
      )}
      {additionItemList?.length > 0 && (
        <CartGoodOptionContainer>
          <GoodOptionItemList
            floatingType={false}
            styleProps={{ width: '100%' }}
            optionLabelList={['추가옵션']}
            itemNodeList={additionItemList}
            onSelect={handleSelectOption}
            handleSelectOptionContainerHeight={handleSelectOptionContainerHeight}
          />
        </CartGoodOptionContainer>
      )}
      {goodDetail.goodName}
    </FlexBoxColumn>
  )
}

export default CartPopupOptionSelect;

CartPopupOptionSelect.propTypes = {
  isGroup: PropTypes.bool,
  // floatingType: PropTypes.bool,
  subGoodItemList: PropTypes.array,
  subGoodDetail: PropTypes.object,
  selectedGoodDetail: PropTypes.object,
  additionItemList: PropTypes.array,
  handleDropDownOption: PropTypes.func,
  handleGroupDropDownOption: PropTypes.func,
  handleSelectOptionContainerHeight: PropTypes.func,
}

const CartGoodOptionContainer = styled(FlexBoxColumn)`
  width: 100%;
  background-color: ${theme.color.background.basic};
  padding: 15px;
    margin-top: 7px;
`